import { render } from "./VideoComponents.vue?vue&type=template&id=66fb9c29"
import script from "./VideoComponents.vue?vue&type=script&lang=js"
export * from "./VideoComponents.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__